module.exports = __webpack_public_path__ + "static/media/whirlwind.e7627932.png";